/*
 * Раскладка диалога заявки. Поля, чипы и пилюли — глобальные классы base.css; здесь только
 * то, чего в макетах не было: перенос полосы чипов, высота поля подсказки и строка очереди.
 */

/* Собственная рамка и отступы браузерного fieldset здесь не нужны: группу обозначает
   подпись, а не рамка. min-width:0 снимает известную особенность fieldset, из-за которой
   он отказывается сжиматься у́же содержимого. */
.field {
  border: none;
  margin: 0;
  padding: 0;
  min-width: 0;
}

.chips {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

/* «Сравнить с…» без второй версии стиля и «Задать контекст» при дайджесте: чип виден (режим
   существует), но не нажимается — почему, говорит подсказка при наведении, а не строка под
   рядом. */
.chips :global(.fchip):disabled,
.modeRow :global(.fchip):disabled {
  opacity: 0.5;
  cursor: default;
}

/* Счётчик подсказки — данные: цифры табличные, чтобы строка не дёргалась при наборе. */
.counter {
  font-variant-numeric: tabular-nums;
}

/* Подсказка — текст, который человек пишет глазами, а не данные: та же гарнитура и высота
   строки, что у всего интерфейса, с возможностью потянуть вниз. */
.area {
  resize: vertical;
  min-height: 84px;
  line-height: 1.5;
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.queue {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.qrow {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

/* Пилюли состояний разной длины («в очереди» против «готово») иначе сдвигали бы подписи
   заявок друг относительно друга — колонка обязана быть ровной. */
.qstate {
  min-width: 84px;
  justify-content: center;
}

/* min-width:0 обязателен: без него длинная подсказка распирает строку и диалог уезжает вбок. */
.qbody {
  flex: 1;
  min-width: 0;
}

.qtitle {
  display: block;
  font-size: 14px;
  color: var(--ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
a.qtitle:hover {
  color: var(--accent-ink);
}

/* Ряд режима «Задать контекст». Стоит вплотную к чипам форматов и читается как их
   продолжение, но отделён от них рядом: это переключатель ПУТИ прогона, а не третий
   формат. Объяснение режима — в поповере ⓘ рядом с чипом (§1 партии 19.09), а не строкой. */
.modeRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

/*
 * Поле контекста. Высота — не «побольше на всякий случай»: сюда вставляют ГОТОВЫЙ ПОСТ, и
 * поле на четыре строки превращает вставленный текст в щель, по которой его нельзя
 * вычитать. 320px — примерно двадцать строк, то есть средний пост канала целиком.
 * Тянуть можно только вниз (`resize: vertical`): горизонтальная тяга ломает раскладку
 * модалки, а ширину даёт сама модалка, расширяясь в этом режиме.
 */
.context {
  resize: vertical;
  min-height: 320px;
  line-height: 1.5;
}
